import React, { useEffect, useState } from 'react';
import { getImageUrl } from '../../../config';
import { LOGIN } from '../../../constants/Copy';
import { ROUTE_LOGIN } from '../../../constants/Routes';
import { Link } from 'react-router-dom';
import './Header.scss';
import { hasValidVideolandCookie } from '../../../helpers/authentication';
import { getExperiment } from '../../../helpers/sitespect';
import { SITESPECT_EXPERIMENT, SITESPECT_EXPERIMENT_NAMES } from '../../../constants/Sitespect';
import cx from 'classnames';
import { matchPath, useLocation } from 'react-router';

export default () => {
	const location = useLocation();
	const isLoggedIn = hasValidVideolandCookie();
	const logo = getImageUrl('/images/vl-logo.svg');
	const [showLoginLink, setShowLoginLink] = useState(false);

	useEffect(() => {
		const isOnLoginLinkExperiment =
			getExperiment(SITESPECT_EXPERIMENT_NAMES.LOGIN_LINK) === SITESPECT_EXPERIMENT.VARIANT;
		setShowLoginLink(
			!isLoggedIn && isOnLoginLinkExperiment && !matchPath(location.pathname, ROUTE_LOGIN)
		);
	}, [isLoggedIn, location.pathname]);

	return (
		<div
			className={cx('onboarding-header', {
				['onboarding-header--with-login']: showLoginLink,
			})}
		>
			<img className="onboarding-header__logo" src={logo} alt="Videoland logo" />
			{showLoginLink && (
				<Link
					className="onboarding-header__login-link onboarding__link"
					tabIndex="0"
					to={ROUTE_LOGIN}
				>
					{LOGIN}
				</Link>
			)}
		</div>
	);
};
